var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFormatpdf(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 32,
    viewBox: "0 0 26 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26 9.38031L16.3853 0L15.2603 10.3107L26 9.38031Z",
    fill: "#BABABA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.13609 15.6782H3.03613V21.3429H4.16684V19.6435H5.02593C6.17867 19.6435 7.10375 18.9638 7.10375 17.6528V17.6366C7.10377 16.4794 6.3622 15.6782 5.13609 15.6782ZM5.95837 17.6771C5.95837 18.1626 5.62802 18.5349 5.06262 18.5349H4.16684V16.8031H5.04059C5.60601 16.8031 5.95837 17.1025 5.95837 17.6608V17.6771Z",
    fill: "#F7F7F7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.94535 15.6782H7.94092V21.3429H9.94535C11.5606 21.3429 12.6767 20.1048 12.6767 18.5106V18.4944C12.6767 16.9002 11.5606 15.6782 9.94535 15.6782ZM11.4946 18.5267C11.4946 19.5302 10.8705 20.2181 9.94535 20.2181H9.07165V16.8031H9.94537C10.8706 16.8031 11.4946 17.5071 11.4946 18.5106L11.4946 18.5267Z",
    fill: "#F7F7F7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5971 16.8112V15.6782H13.6836V21.3429H14.8143V19.1499H17.2667V18.0169H14.8143V16.8112H17.5971Z",
    fill: "#F7F7F7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2617 10.3107L16.3867 0H3.03857V10.5961V14.6538H20.6315V22.3671H3.03857V32H25.9529L25.9907 14.38L22.0091 9.72617L15.2617 10.3107Z",
    fill: "#EEEEEE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0078 9.72623L25.9894 14.38L26.0001 9.38037L22.0078 9.72623Z",
    fill: "#D6D6D4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M5.03976 16.8032H4.16602V18.535H5.06179C5.62719 18.535 5.95754 18.1627 5.95754 17.6772V17.661C5.95757 17.1026 5.60518 16.8032 5.03976 16.8032Z",
    fill: "#F46856"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M3.0376 14.6538H0V22.3671H3.0376H20.6306V14.6538H3.0376ZM7.10295 17.6527C7.10295 18.9637 6.17787 19.6434 5.02513 19.6434H4.16605V21.3428H3.03533V15.6781H5.13529C6.3614 15.6781 7.10297 16.4793 7.10297 17.6365V17.6527H7.10295ZM12.6758 18.5105C12.6758 20.1047 11.5598 21.3428 9.9445 21.3428H7.94007V15.6781H9.9445C11.5598 15.6781 12.6758 16.9001 12.6758 18.4943V18.5105ZM17.5953 16.8111H14.8125V18.0168H17.2649V19.1498H14.8125V21.3428H13.6818V15.6781H17.5953V16.8111Z",
    fill: "#F46856"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M9.94449 16.8032H9.0708V20.2182H9.94452C10.8697 20.2182 11.4937 19.5304 11.4937 18.5269V18.5107C11.4937 17.5072 10.8697 16.8032 9.94449 16.8032Z",
    fill: "#F46856"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M3.03743 14.0519V10.5962L0.452637 14.049H3.03513L3.03743 14.0519Z",
    fill: "#CB5642"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M3.03531 14.0488H0.45281L0 14.6544H3.0376V14.0518L3.03531 14.0488Z",
    fill: "#A5423A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormatpdf);
export default __webpack_public_path__ + "static/media/format=pdf.96867edc8d80d99d0258c51ca9374587.svg";
export { ForwardRef as ReactComponent };